export default __webpack_public_path__ + "static/media/dark10.943abd45.png";